import { render, staticRenderFns } from "./FormLv3.vue?vue&type=template&id=56540d56&scoped=true"
import script from "./FormLv3.vue?vue&type=script&lang=js"
export * from "./FormLv3.vue?vue&type=script&lang=js"
import style0 from "./FormLv3.vue?vue&type=style&index=0&id=56540d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56540d56",
  null
  
)

export default component.exports